import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation, computed, inject } from '@angular/core';
import { ProfileService } from '../../process';

@Component({
  selector: 'product-label',
  standalone: true,
  template: `
    @if(productLabel$$()) {
    <span>{{ productLabel$$() }}</span>
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLabelComponent {
  private _profileService = inject(ProfileService);

  get productLabel$$(): Signal<string> {
    return computed(() => this._profileService.productLabel$$());
  }
}
